import { useUserStore } from "@/stores/userStore";
export async function requireAuth(to, from, next) {
    const userStore = useUserStore();
    await userStore.loadUser(false);
    if (userStore.isAnonymous) {
        next({
            path: "/login/start",
            query: {
                redirect: to.fullPath,
            },
        });
        return;
    }
    next();
}
